import React from 'react';
import TailwindModal from './TailwindModal';
import LoaderIcon from './LoaderIcon';

const ActionConfirmModal = ({ isOpen, onClose, onConfirm, title, message, loading, confirmText = "Confirm", type = "danger" }) => {
    const styles = {
        danger: {
            bg: "bg-red-100",
            iconText: "text-red-600",
            buttonBg: "bg-red-600",
            buttonHover: "hover:bg-red-700",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3m0 4h.01M10.29 3.86l-7.5 13A2 2 0 004.5 20h15a2 2 0 001.71-3.14l-7.5-13a2 2 0 00-3.42 0z" />
                </svg>
            )
        },
        success: {
            bg: "bg-emerald-100",
            iconText: "text-emerald-600",
            buttonBg: "bg-emerald-600",
            buttonHover: "hover:bg-emerald-700",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            )
        },
        info: {
            bg: "bg-blue-100",
            iconText: "text-blue-600",
            buttonBg: "bg-blue-600",
            buttonHover: "hover:bg-blue-700",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            )
        }
    };

    const currentStyle = styles[type] || styles.danger;

    return (
     <TailwindModal isOpen={isOpen} onClose={onClose}>
  <div className="w-full overflow-hidden rounded-2xl bg-white shadow-2xl">
    {/* Header */}
    <div className="flex items-start gap-4 p-6">
      <div className={`flex h-12 w-12 items-center justify-center rounded-full ${currentStyle.bg}`}>
        {currentStyle.icon}
      </div>

      <div className="flex-1">
        <h2 className="text-lg font-semibold text-slate-900">
          {title}
        </h2>

        <div className="mt-2 text-sm leading-6 text-slate-500 whitespace-pre-wrap">
          {message}
        </div>
      </div>
    </div>

    {/* Footer */}
    <div className="flex justify-end gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4">
      <button
        onClick={onClose}
        disabled={loading}
        className="rounded-xl border border-slate-300 bg-white px-5 py-2.5 text-sm font-medium text-slate-700 transition-all duration-200 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Cancel
      </button>

      <button
        onClick={onConfirm}
        disabled={loading}
        className={`inline-flex min-w-[120px] items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-medium text-white transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-60 ${currentStyle.buttonBg} ${currentStyle.buttonHover}`}
      >
        {loading ? (
          <>
            <LoaderIcon className="h-4 w-4" />
            Processing...
          </>
        ) : (
          confirmText
        )}
      </button>
    </div>
  </div>
</TailwindModal>
    );
};

export default ActionConfirmModal;
